export function formatBrazilPhone(raw?: string | null): string {
  // Guarda explícita: o parâmetro default (= "") só cobre `undefined`, não
  // `null` — e a API retorna null (não omite o campo) pra hospitais/médicos
  // sem telefone cadastrado, o que quebrava o .replace() abaixo.
  if (!raw) return "";

  const digits = raw.replace(/\D/g, "").slice(0, 11);

  if (digits.length <= 2) return digits;                      
  if (digits.length <= 7)                                     
    return digits.replace(/^(\d{2})(\d{0,5})/, "($1) $2");
  return digits.replace(
    /^(\d{2})(\d{5})(\d{0,4}).*/,
    "($1) $2-$3"
  );
}